import React from 'react'

// Material UI
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TextField, Container } from '@mui/material';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';



function Header({
    year, month, employeeCodeIsValid, minWorkHour, workableDay_Youbi, weekendAvailableCount, shiftTable, updatedAt, handleChangeForEmployeeCode, 
    activeTab, handleTabChange}) {

    return (
        <Box sx={{ width: "100%", my: 2, textAlign: "center" }}>

            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 4 }}>
                <Tabs
                    value={activeTab || "next"} 
                    onChange={handleTabChange}
                    centered
                    sx={{
                        '& .MuiTab-root': {
                            fontSize: '16px',
                            fontWeight: 'bold',
                        },
                        '& .Mui-selected': {
                            color: '#4A90E2 !important',
                        },
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#4A90E2',
                        }
                    }}
                >
                    <Tab label="シフト変更申請" value="change" />
                    <Tab label="翌月希望シフト" value="next" />
                </Tabs>
            </Box>

            <Typography
                style={{ 
                    color: "#4A90E2",
                    fontSize: "32px",
                    fontWeight: "bold",
                    marginBottom: "20px"
                }}
                variant="h2"
            >
                {`${activeTab==="next" ? `${year}年${month}月シフト提出` : "シフト変更申請"}`}
            </Typography>

            <Grid container sx={{ my: 2 }}>
                <Grid item xs={false} md={2}></Grid>
                <Grid item xs={12} sm={6} md={4} sx={{ mb: { xs: activeTab==="next" ? 4 : 0, md: 0 } }}>
                    <TextField 
                        id="outlined-basic" 
                        label="従業員番号" 
                        variant="outlined"
                        size='small'
                        sx={{
                            mb:1
                        }}
                        onChange={handleChangeForEmployeeCode}
                        error={!employeeCodeIsValid}
                    />
                    {employeeCodeIsValid && activeTab==="next" && (
                        <Container sx={{ display: "flex", justifyContent: "center" }}>
                            <Box sx={{ textAlign: "left" }}>
                                <Typography sx={{ fontSize: "13px" }}>{`前回登録日:${updatedAt}`}</Typography>
                                <Typography sx={{ fontSize: "13px" }}>{`月間稼働時間:${minWorkHour}時間`}</Typography>
                                <Typography sx={{ fontSize: "13px" }}>{`${workableDay_Youbi}出勤回数:${weekendAvailableCount || 0}回以上`}</Typography>
                            </Box>
                        </Container>
                    )}
                </Grid>
                {activeTab==="next" && (
                    <Grid item xs={12} sm={6} >
                        <TableContainer 
                            component={Paper} 
                            sx={{ 
                                width: {
                                    xs: "100%",
                                    md: "60%"
                                },
                                maxWidth: 600, 
                                overflow: 'hidden', 
                                boxShadow: 'none', 
                                background: 'transparent' 
                            }}>
                            <Table sx={{ minWidth: 250, borderCollapse: 'collapse', border: 'none' }}>
                            <TableBody>
                                {shiftTable && shiftTable.map((row, rowIndex) => (
                                <TableRow key={rowIndex}>
                                    {row.map((cell, cellIndex) => (
                                    <TableCell
                                        key={cellIndex}
                                        align="center"
                                        sx={{
                                        padding: '4px',
                                        border: 2,
                                        borderColor: 'grey.300',
                                        borderTop: rowIndex === 0 ? 'none' : '1px solid grey.300', // 最初の行の上線はなし
                                        borderLeft: cellIndex === 0 ? 'none' : '1px solid grey.300', // 最初の列の左線はなし
                                        borderBottom: rowIndex === shiftTable.length - 1 ? 'none' : '1px solid grey.300', // 最後の行の下線はなし
                                        borderRight: cellIndex === row.length - 1 ? 'none' : '1px solid grey.300', // 最後の列の右線はなし
                                        verticalAlign: 'middle'
                                        }}
                                    >
                                        {cell}
                                    </TableCell>
                                    ))}
                                </TableRow>
                                ))}
                            </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                    )
                }
            </Grid>

        </Box>
    )
}

export default Header